<template>
  <a
    v-if="path=='https://instawp.com?utm_source=onboarding'"
    :href="path"
    class="w-full"
    style="max-width: 153px"
    @click.prevent.stop="openInNewTab()"
  >
    <slot>
      <img
        class="h-14 lg:hidden "
        src="../../images/Authentication/instawp-logo.svg"
        style="max-width: 153px"
        alt=""
        srcset=""
      >
    </slot>
  </a>
  <inertia-link
    v-else
    :href="path"
  >
    <slot>
      <img
        class="h-14 lg:hidden "
        src="../../images/Authentication/instawp-logo.svg"
        style="max-width: 153px"
        alt=""
        srcset=""
      >
    </slot>
  </inertia-link>
</template>
<script>
export default {
    
    props: {
        path: {
            type: String,
            default: '/'
        }
    },
    methods:{
        openInNewTab() {
            Object.assign(document.createElement('a'), {
                target: '_blank',
                rel: 'noopener noreferrer',
                href: this.path,
            }).click();
        }
    }
};
</script>